module.exports = __webpack_public_path__ + "img/icon-empty-data.7a6f3959.svg";